import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import moment from "moment";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CustomizedTable from "../../../components/UI/CustomizedTable";

import {
  deleteBestPrice,
  exportBestPrice,
  getBestPrice,
} from "../../../utils/ApiCalls/BestPrice";
import { downloadFile } from "../../../utils/ApiCalls/Document";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { message } from "antd";
import BestPriceModal from "./BestPriceModal";

const BestPrice = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Best Price",
      route: "/cms /best-price",
    },
  ];
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Best Price",window?.location?.pathname)) {
      await deleteBestPrice(id);
      getData();
    } else {
      message.error("Missing Permission for delete");
    }
  };
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [{ permission }, dispatch] = useDataLayerValue();
  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
     {
      title: "Form ID",
      dataIndex: "id",
      key: "id",
      width: 150,
    },
    {
      title: "Booking no",
      dataIndex: "booking_no",
      key: "booking_no",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 50,
    },
    {
      title: "Sailing date",
      dataIndex: "sailing_date",
      key: "sailing_date",
      width: 150,
    },

    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 50,
      render: (item, record) => (
        <p>
          {record?.first_name} {record?.last_name}
        </p>
      ),
    },
    {
      title: "Lower rate message",
      dataIndex: "lower_rate_found_or_reserved",
      key: "lower_rate_found_or_reserved",
      width: 200,
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      width: 50,
    },
    {
      title: "Website link ",
      dataIndex: "website_link",
      key: "website_link",
      width: 50,
      render: (item) => (
        <div className="table_action_btn">
          {" "}
          <div
            style={{ width: "100px" }}
            onClick={async () => {
              try {
                navigator.clipboard
                  .writeText(`${item}`)
                  .then(() => {
                    alert("successfully copied");
                  })
                  .catch(() => {
                    alert("something went wrong");
                  });
              } catch (error) {
                console.error("Error copying to clipboard:", error);
              }
            }}
            className="btn copy_btn"
          >
            <span data-toggle="tooltip" title="Copy Url">
              Copy Url
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "File",
      dataIndex: "file",
      key: "file",
      width: 50,
      render: (item, record) => (
        <div className="table_action_btn">
          {" "}
          {record?.file_data?.length > 0 ? (
            <BestPriceModal record={record} downloadFileURL={downloadFileURL} />
          ) : (
            "-"
          )}
          {/* {item ? (
            <div
              style={{ width: "100px", background: "var(--red)" }}
              onClick={() => {
                downloadFileURL(item);
              }}
              className="btn copy_btn"
            >
              <span data-toggle="tooltip" title="download">
                Download
              </span>
            </div>
          ) : (
            " - "
          )} */}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "file",
      key: "file",
      width: 50,
      render: (item, record) => (
        <div className="table_action_btn">
          {" "}
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  async function downloadFileURL(url) {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    await downloadFile(url);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  }
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const getData = async (value) => {
    let data = await getBestPrice({ page: value, limit: pageSize });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleDownload = async (e) => {
    if (checkPermission(permission, "download_per", "Best Price",window?.location?.pathname)) {
      try {
        const response = await exportBestPrice();
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "bestprice.xlsx";

        // Append the link to the body and trigger the download
        document.body.appendChild(a);
        a.click();

        // Remove the link from the body
        document.body.removeChild(a);
      } catch (error) {
        console.error("Error downloading Excel file:", error);
      }
    } else {
      message.error("Download permission missing");
    }
  };
  return (
    <Layout type={"read_per"} module_data={"Best price"}>
      <CustomHeaderTitle title={"Best price"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Best price"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">Best price List</h5>
                <div className="two_item">
                  {/* <Link to="/website/cms/news-letter/add" className="btn add_v_btn mx-2">
                    Add Best price
                  </Link> */}
                  <Link
                    onClick={(e) => handleDownload(e)}
                    className="btn export_v_btn mx-2"
                  >
                    Export Best Price
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <div className="table_holder">
                  <CustomizedTable
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={columns}
                    rows={rows}
                    title={"NewsLetter"}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default BestPrice;
